import { Box, Typography, IconButton, Modal } from '@mui/material'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const FaceMatchDetails = ({ vendorData }) => {
  const { t } = useTranslation(['common'])
  const [selectedImage, setSelectedImage] = useState(null)

  if (!vendorData || !vendorData.face_match) {
    return null
  }

  const faceMatch = vendorData.face_match

  const summary = `${t('common:score')}: ${faceMatch.score} - ${t('common:status')}: ${faceMatch.status}`

  return (
    <>
      <CollapsibleSection title={t('common:faceMatchDetails')} summary={summary}>

        <Box className={styles.gridItems}>
          <GridItem name={t('common:score')} value={faceMatch.score} />
          <GridItem name={t('common:status')} value={faceMatch.status} />
        </Box>

        <Box className={styles.imagesContainer}>
          {faceMatch.source_image && (
            <Box className={styles.imageBox} onClick={() => setSelectedImage(faceMatch.source_image)}>
              <Box className={styles.imageHeader}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {t('common:sourceImage')}
                </Typography>
              </Box>
              <Box className={styles.imageWrapper}>
                <img src={faceMatch.source_image} alt="Source" className={styles.verificationImage} />
              </Box>
            </Box>
          )}

          {faceMatch.target_image && (
            <Box className={styles.imageBox} onClick={() => setSelectedImage(faceMatch.target_image)}>
              <Box className={styles.imageHeader}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {t('common:targetImage')}
                </Typography>
              </Box>
              <Box className={styles.imageWrapper}>
                <img src={faceMatch.target_image} alt="Target" className={styles.verificationImage} />
              </Box>
            </Box>
          )}
        </Box>
      </CollapsibleSection>

      {/* Lightbox Modal */}
      <Modal
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        sx={{ zIndex: 99999 }}
      >
        <Box className={styles.modal} onClick={() => setSelectedImage(null)}>
          <Box className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <IconButton className={styles.closeButton} onClick={() => setSelectedImage(null)}>
              <CloseIcon />
            </IconButton>
            <img src={selectedImage} alt="Face" className={styles.modalImage} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
